export default __webpack_public_path__ + "static/media/Contact-US.4565786e.svg";